const difficultyLevels: {
  value: number;
  label: string;
  description: string;
  examples: string[];
}[] = [
  {
    value: 1,
    label: 'Easy',
    description: 'There are no fitness requirements.',
    examples: ['Sightseeing', 'Guided safari'],
  },
  {
    value: 2,
    label: 'Moderate',
    description:
      'You just need a basic level of fitness. No experience is necessary.',
    examples: [
      'Short hikes on mostly flat terrain',
      'Beginners surfing',
      'Beginners yoga',
    ],
  },
  {
    value: 3,
    label: 'Demanding',
    description:
      "You'll need a good level of fitness. Some experience is nice to have, but you'll be taught everything you need to know on the trip.",
    examples: [
      'Canoe across Scotland (5 days)',
      'UK Three Peaks (24 hour hiking challenge)',
    ],
  },
  {
    value: 4,
    label: 'Tough',
    description:
      "You'll need a strong level of fitness and will want to exercise multiple times a week before the trip. You may need existing experience.",
    examples: [
      'Summit 4000m mountains',
      'Winter hiking',
      'Everest Base Camp',
      'Kilimanjaro',
    ],
  },
  {
    value: 5,
    label: 'Extreme',
    description:
      "A great level of fitness is required - you're the type of person who runs marathons or summits 6000m mountains. These trips are very challenging and often require significant existing experience.",
    examples: [
      'Aconcagua',
      'Mt Elbrus',
      'Advanced Ice Climbing',
      'Mt Everest (summit)',
    ],
  },
];

export default difficultyLevels;
